import { render, staticRenderFns } from "./ShearsDivider.vue?vue&type=template&id=1da6384b&"
import script from "./ShearsDivider.vue?vue&type=script&lang=js&"
export * from "./ShearsDivider.vue?vue&type=script&lang=js&"
import style0 from "./ShearsDivider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports